import { render } from "./PricesPicker.vue?vue&type=template&id=503234cc"
import script from "./PricesPicker.vue?vue&type=script&lang=js"
export * from "./PricesPicker.vue?vue&type=script&lang=js"

import "./PricesPicker.vue?vue&type=style&index=0&id=503234cc&lang=css"

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__